import { render } from "./EnquiryList.vue?vue&type=template&id=6939960e"
import script from "./EnquiryList.vue?vue&type=script&lang=js"
export * from "./EnquiryList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__